import { render, staticRenderFns } from "./equipamento.vue?vue&type=template&id=f4532d72&scoped=true&"
import script from "./equipamento.vue?vue&type=script&lang=ts&"
export * from "./equipamento.vue?vue&type=script&lang=ts&"
import style0 from "./equipamento.vue?vue&type=style&index=0&id=f4532d72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4532d72",
  null
  
)

export default component.exports